import { BaseModel } from "./BaseModel";

export class StatisticsModel extends BaseModel {
  protected AuthState: boolean = true;
  protected RouteName: string = "Statistics";
}
